/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderMetadataInfo } from './ProviderMetadataInfo';
import {
    ProviderMetadataInfoFromJSON,
    ProviderMetadataInfoFromJSONTyped,
    ProviderMetadataInfoToJSON,
} from './ProviderMetadataInfo';

/**
 * Request body for the /custom-auth/connect endpoint. The first call supplies the flow inputs; subsequent calls supply sessionId and callbackParams to resume after a redirect.
 * @export
 * @interface CustomAuthConnectRequest
 */
export interface CustomAuthConnectRequest {
    /**
     * The Ampersand project ID or project name. Required on the first call.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    projectIdOrName: string;
    /**
     * The provider that this app connects to. Required on the first call (when sessionId is not present); ignored on resume calls. Conditional requirement is enforced at the application layer.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    provider?: string;
    /**
     * Your application's identifier for the organization or workspace that this connection belongs to. Supplied on the first call; ignored on resume calls (the parked flow's identity is used).
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    groupRef?: string;
    /**
     * The display name for the group. Defaults to groupRef if not provided. Supplied on the first call; ignored on resume calls.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    groupName?: string;
    /**
     * The ID that your app uses to identify the user whose SaaS credential will be used. Supplied on the first call; ignored on resume calls (the parked flow's identity is used).
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    consumerRef?: string;
    /**
     * The display name for the consumer. Defaults to consumerRef if not provided. Supplied on the first call; ignored on resume calls.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    consumerName?: string;
    /**
     * 
     * @type {{ [key: string]: ProviderMetadataInfo; }}
     * @memberof CustomAuthConnectRequest
     */
    providerMetadata?: { [key: string]: ProviderMetadataInfo; };
    /**
     * ID of the provider app. If omitted, the default provider app set up on the Dashboard is assumed.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    providerAppId?: string;
    /**
     * The consumer-supplied custom auth inputs (keyed by CustomAuthInput.name). Supplied on the first call (when sessionId is not present).
     * @type {{ [key: string]: any; }}
     * @memberof CustomAuthConnectRequest
     */
    customAuth?: { [key: string]: any; };
    /**
     * Identifies an in-progress flow to resume after a redirect. Returned in a prior redirect response. When present, provider and customAuth are not required.
     * @type {string}
     * @memberof CustomAuthConnectRequest
     */
    sessionId?: string;
    /**
     * The query/body params the provider sent to the callback, forwarded to resume the flow.
     * @type {{ [key: string]: string; }}
     * @memberof CustomAuthConnectRequest
     */
    callbackParams?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CustomAuthConnectRequest interface.
 */
export function instanceOfCustomAuthConnectRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectIdOrName" in value;

    return isInstance;
}

export function CustomAuthConnectRequestFromJSON(json: any): CustomAuthConnectRequest {
    return CustomAuthConnectRequestFromJSONTyped(json, false);
}

export function CustomAuthConnectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthConnectRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectIdOrName': json['projectIdOrName'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'groupRef': !exists(json, 'groupRef') ? undefined : json['groupRef'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'consumerRef': !exists(json, 'consumerRef') ? undefined : json['consumerRef'],
        'consumerName': !exists(json, 'consumerName') ? undefined : json['consumerName'],
        'providerMetadata': !exists(json, 'providerMetadata') ? undefined : (mapValues(json['providerMetadata'], ProviderMetadataInfoFromJSON)),
        'providerAppId': !exists(json, 'providerAppId') ? undefined : json['providerAppId'],
        'customAuth': !exists(json, 'customAuth') ? undefined : json['customAuth'],
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'callbackParams': !exists(json, 'callbackParams') ? undefined : json['callbackParams'],
    };
}

export function CustomAuthConnectRequestToJSON(value?: CustomAuthConnectRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectIdOrName': value.projectIdOrName,
        'provider': value.provider,
        'groupRef': value.groupRef,
        'groupName': value.groupName,
        'consumerRef': value.consumerRef,
        'consumerName': value.consumerName,
        'providerMetadata': value.providerMetadata === undefined ? undefined : (mapValues(value.providerMetadata, ProviderMetadataInfoToJSON)),
        'providerAppId': value.providerAppId,
        'customAuth': value.customAuth,
        'sessionId': value.sessionId,
        'callbackParams': value.callbackParams,
    };
}

